import { PdRatingInput } from "./pd-rating/PdRatingInput.js";
//#region src/pd-rating/pd-rating-input.ts
var tag = "pd-rating-input";
if (!customElements.get(tag)) customElements.define(tag, PdRatingInput);
//#endregion
export { PdRatingInput };
